/* eslint-disable react/no-danger -- synchronous inline script required before Next.js hydration */

/**
 * Runs synchronously in <head> before Next.js hydrates.
 * Email links like `https://host.com//a/fm` leave pathname as `//a/fm`, which
 * the App Router mis-parses as host `a` when calling history.replaceState.
 */
const NormalizePathnameScript = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: `(function(){try{var p=location.pathname,n=p.replace(/\\/+/g,"/");if(!n)n="/";if(n!==p){history.replaceState(null,"",n+location.search+location.hash)}}catch(e){}})();`
    }}
  />
);

export default NormalizePathnameScript;
